// ── useBackClose — закрыть окно кнопкой «Назад» телефона или Esc ─────────────
// Пока open, окно стоит в общем стеке: Esc и «Назад» закрывают только верхнее
// (последнее открытое), а не все окна сразу.
// App на «Назад» телефона сначала зовёт closeTopOnBack(): закрылось окно — и всё,
// иначе уходит с экрана.

import { useEffect, useRef } from 'react';

const stack = [];
const backHandlers = [];

// Своё действие на «Назад» (fn вернёт true, если что-то закрыла). Возвращает «снять».
export function registerBack(fn) {
  backHandlers.push(fn);
  return () => { const i = backHandlers.lastIndexOf(fn); if (i >= 0) backHandlers.splice(i, 1); };
}

// «Назад» телефона: закрыть последнее открытое. true — было что закрывать.
export function closeTopOnBack() {
  for (let i = backHandlers.length - 1; i >= 0; i--) {
    try { if (backHandlers[i]()) return true; } catch { /* следующее */ }
  }
  return false;
}
function onKey(e) {
  if (e.key !== 'Escape' || !stack.length) return;
  e.stopPropagation();
  stack[stack.length - 1].current?.();
}

export default function useBackClose(open, close) {
  const ref = useRef(close);
  ref.current = close;
  useEffect(() => {
    if (!open) return undefined;
    stack.push(ref);
    if (stack.length === 1) window.addEventListener('keydown', onKey);
    const unreg = registerBack(() => { ref.current?.(); return true; });
    return () => {
      unreg();
      const i = stack.lastIndexOf(ref);
      if (i >= 0) stack.splice(i, 1);
      if (!stack.length) window.removeEventListener('keydown', onKey);
    };
  }, [open]);
}
